export const colors = {
  lightSalmon : "#FFA07A"
}